<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { cn } from "@/shared/lib/utils"

const props = defineProps<{
  class?: HTMLAttributes["class"]
}>()
</script>

<template>
  <div
    data-slot="skeleton"
    aria-hidden="true"
    :class="
      cn(
        'bg-muted animate-pulse rounded-md motion-reduce:animate-none',
        props.class,
      )
    "
  />
</template>
